/**
 * PersonFunction reducer.
 * @module reducers/personfunction/personfunction
 */

import {
  GET_PERSONFUNCTIONS,
  SET_PERSONFUNCTION,
} from '../../constants/ActionTypes';

const initialState = {
  loaded: false,
  loading: false,
  error: null,
  items: [],
  subrequests: {},
};

/**
 * PersonFunction reducer.
 * @function personfunction
 * @param {Object} state Current state.
 * @param {Object} action Action to be handled.
 * @returns {Object} New state.
 */
export function personfunction(state = initialState, action = {}) {
  switch (action.type) {
    case `${SET_PERSONFUNCTION}_PENDING`:
    case `${GET_PERSONFUNCTIONS}_PENDING`:
      return action.subrequest
        ? {
            ...state,
            subrequests: {
              ...state.subrequests,
              [action.subrequest]: {
                ...(state.subrequests[action.subrequest] || {
                  items: [],
                }),
                items: [],
                error: null,
                loaded: false,
                loading: true,
              },
            },
          }
        : {
            ...state,
            error: null,
            loading: true,
            loaded: false,
          };

    case `${GET_PERSONFUNCTIONS}_SUCCESS`:
    case `${SET_PERSONFUNCTION}_SUCCESS`:
      return action.subrequest
        ? {
            ...state,
            subrequests: {
              ...state.subrequests,
              [action.subrequest]: {
                error: null,
                items: action.result.persons,
                loaded: true,
                loading: false,
              },
            },
          }
        : {
            ...state,
            error: null,
            items: action.result.persons,
            loaded: true,
            loading: false,
          };

    case `${GET_PERSONFUNCTIONS}_FAIL`:
    case `${SET_PERSONFUNCTION}_FAIL`:
      return action.subrequest
        ? {
            ...state,
            subrequests: {
              ...state.subrequests,
              [action.subrequest]: {
                error: action.error,
                items: [],
                loading: false,
                loaded: false,
              },
            },
          }
        : {
            ...state,
            error: action.error,
            items: [],
            loading: false,
            loaded: false,
          };

    default:
      return state;
  }
}
